/**
 * This file is auto-generated from ChatOfflineFooter.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const offlineTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'You are offline';
        case 'pl':
            return 'Jesteś offline';
    }
};

export const offlineMessage: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Check your internet connection.';
        case 'pl':
            return 'Sprawdź swoje połączenie z internetem.';
    }
};
